import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import LandingPage from './LandingPage'
import PinValidation from './PinValidation/PinValidation'
import ReportListing from './ReportListing/ReportListing'
import FarmInformation from './FarmInformation/FarmInformation'
import ProductivityRankByRegion from './reports/ProductivityRankByRegion/ProductivityRankByRegion'
import ProductiveEnvironment from './reports/ProductiveEnvironment/ProductiveEnvironment'
import PlantingTime from './reports/PlantingTime/PlantingTime'
import PopulationRangeByProductivity from './reports/PopulationRangeByProductivity/PopulationRangeByProductivity'
import PopulationVariety from './reports/PopulationVariety/PopulationVariety'
import FormReport from './reports/FormReport/FormReport'

const Routes = function () {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/farmers/portal" component={LandingPage} />
        <Route path="/farmers/validation" component={PinValidation} />
        <Route path="/farmers/reports" component={ReportListing} />
        <Route path="/farmers/farm-information" component={FarmInformation} />
        <Route exact path="/farmers/form-report" component={FormReport} />
        <Route exact path="/farmers/productivity-rank-by-region" component={ProductivityRankByRegion} />
        <Route exact path="/farmers/population-range-by-productivity" component={PopulationRangeByProductivity} />
        <Route exact path="/farmers/productive-environment" component={ProductiveEnvironment} />
        <Route exact path="/farmers/planting-time" component={PlantingTime} />
        <Route exact path="/farmers/population-variety" component={PopulationVariety} />
      </Switch>
    </BrowserRouter>
  )
}

export default Routes
